import log from "loglevel";

const MODE = import.meta.env.VITE_MODE;

const logger = log;

switch (MODE) {
  case "debug":
    logger.setLevel("debug");
    break;
  case "development":
    logger.setLevel("info");
    break;
  case "production":
  default:
    logger.setLevel("error");
    break;
}

export { logger };
